// extracted by mini-css-extract-plugin
export var promotionLink = "_vx-0";